import { useEffect, useState } from "react";
import { countdownTo, formatCountdown } from "@shared/dates";

interface Props {
  targetIso: string;
  onZero?: () => void;
}

export function Countdown({ targetIso, onZero }: Props) {
  const [text, setText] = useState("--:--:--");
  useEffect(() => {
    const target = new Date(targetIso);
    let fired = false;
    const update = () => {
      const c = countdownTo(target);
      setText(formatCountdown(c));
      if (c.totalSeconds === 0 && !fired) {
        fired = true;
        onZero?.();
      }
    };
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, [targetIso, onZero]);
  return <span suppressHydrationWarning>{text}</span>;
}
